import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    name: '登陆',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/404',
    name: '404页面',
    component: Main,
    children: [
      {
        path: '/404',
        name: '页面找不到啦~',
        component: () => import('@/view/errorPage/404'),
        meta: {
          name: '页面丢失'
        }
      }
    ]
  },
  {
    path: '/500',
    name: '500页面',
    component: Main,
    children: [
      {
        path: '/500',
        name: '页面出错啦~',
        component: () => import('@/view/errorPage/500'),
        meta: {
          name: '页面出错'
        }
      }
    ]
  },

  {
    path: '/',
    redirect: '/evidenceCenter/dataAnalytics',
    name: '证据管理',
    component: Main,
    children: [
      {
        path: '/evidenceCenter/dataAnalytics',
        name: ' AI数据分析',
        component: () =>
          import('@/view/evidenceCenter/dataAnalytics.vue'),
        meta: {
          type: '菜单',
          name: '数据分析',
          parentMenu: 'evidenceCenter:-'
        }
      }
    ]
  },
  {
    path: '/',
    redirect: '/evidenceCenter/intelligenceAnalysis',
    name: '证据管理',
    component: Main,
    children: [
      {
        path: '/evidenceCenter/intelligenceAnalysis',
        name: ' AI执行情报分析',
        component: () =>
          import('@/view/evidenceCenter/intelligenceAnalysis.vue'),
        meta: {
          type: '菜单',
          name: 'AI执行情报分析',
          parentMenu: 'evidenceCenter:-'
        }
      }
    ]
  },
  {
    path: '/',
    redirect: '/evidenceCenter/partiesDataAnalytics',
    name: '证据管理',
    component: Main,
    children: [
      {
        path: '/evidenceCenter/partiesDataAnalytics',
        name: 'AI溯源情报分析',
        component: () =>
          import('@/view/evidenceCenter/partiesDataAnalytics.vue'),
        meta: {
          type: '菜单',
          name: 'AI溯源情报分析',
          parentMenu: 'evidenceCenter:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '系统管理',
    component: Main,
    children: [
      {
        path: '/systemCenter/userAdmin',
        name: '用户管理',
        component: () =>
          import('@/view/systemCenter/userAdmin/index.vue'),
        meta: {
          type: '菜单',
          name: '用户管理',
          parentMenu: 'systemCenter:-'
        }
      }
    ]
  },
  // {
  //   path: '/',
  //   redirect: '/informationCenter/dataAnalytics',
  //   name: '情报管理',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/dataAnalytics',
  //       name: '数据分析',
  //       component: () =>
  //         import('@/view/intelligenceAnalysis/dataAnalytics.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '数据分析',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   redirect: '/informationCenter/intelligenceAnalysis',
  //   name: '情报管理',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/intelligenceAnalysis',
  //       name: '执行情报分析',
  //       component: () =>
  //         import('@/view/intelligenceAnalysis/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '执行情报分析',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // redirect: '/informationCenter/rightsProtectionReport',
  //   name: '情报管理',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/partiesDataAnalytics',
  //       name: '溯源情报分析',
  //       component: () =>
  //         import('@/view/partiesDataAnalytics/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '溯源情报分析',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // redirect: '/informationCenter/administrative',
  //   // name: '行政',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/administrative',
  //       name: '行政',
  //       component: () =>
  //         import('@/view/informationCenter/punishmentCases/administrative.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '行政',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     },
  //     {
  //       path: '/informationCenter/customs',
  //       name: '海关',
  //       component: () =>
  //         import('@/view/informationCenter/punishmentCases/customs.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '海关',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     },
  //     {
  //       path: '/informationCenter/civil',
  //       name: '民事',
  //       component: () =>
  //         import('@/view/informationCenter/punishmentCases/civil.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '民事',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     },

  //     {
  //       path: '/informationCenter/criminal',
  //       name: '刑事',
  //       component: () =>
  //         import('@/view/informationCenter/punishmentCases/criminal.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '刑事',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // redirect: '/informationCenter/patentEvaluation',
  //   name: '情报管理',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/patentEvaluation',
  //       name: '专利检索',
  //       component: () =>
  //         import('@/view/informationCenter/patentEvaluation/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '专利检索',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   // redirect: '/informationCenter/rightsProtectionReport',
  //   name: '情报管理',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/informationCenter/rightsProtectionReport',
  //       name: '维权检索',
  //       component: () =>
  //         import('@/view/informationCenter/rightsProtectionReport/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '维权检索',
  //         parentMenu: 'informationCenter:-'
  //       }
  //     }
  //   ]
  // },

  {
    path: '/',
    name: '知识图谱',
    component: Main,
    children: [
      {
        path: '/knowledgeGraph',
        name: '知识图谱',
        component: () =>
          import('@/view/knowledgeGraph/index.vue'),
        meta: {
          type: '菜单',
          name: '知识图谱',
          parentMenu: 'knowledgeGraph:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '关系图谱',
    component: Main,
    children: [
      {
        path: '/relationalGraph',
        name: '关系图谱',
        component: () =>
          import('@/view/relationalGraph/index.vue'),
        meta: {
          type: '菜单',
          name: '关系图谱',
          parentMenu: 'relationalGraph:-'
        }
      }
    ]
  },

  // {
  //   path: '/',
  //   name: '侵权地图',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/infringementMap',
  //       name: '侵权地图',
  //       component: () =>
  //         import('@/view/infringementMap/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '侵权地图',
  //         parentMenu: 'infringementMap:-'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '当事人数据分析',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/partiesDataAnalytics',
  //       name: '当事人数据分析',
  //       component: () =>
  //         import('@/view/partiesDataAnalytics/index.vue'),
  //       meta: {
  //         type: '菜单',
  //         name: '当事人数据分析',
  //         parentMenu: 'partiesDataAnalytics:-'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/',
    name: '行业分析报告',
    component: Main,
    children: [
      {
        path: '/industryAnalysis',
        name: '行业分析报告',
        component: () =>
          import('@/view/industryAnalysis/index.vue'),
        meta: {
          type: '菜单',
          name: '行业分析报告'
        }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js